import styled from 'styled-components'

import { colors } from '../../constants/colors'
import { USER_TYPES } from '../../constants/enums'

interface TagProps {
  $variant: USER_TYPES | string
}

const getTagColor = (variant: USER_TYPES | string) => {
  switch (variant) {
    case USER_TYPES.STUDENT:
      return {
        background: colors.ppalStudent,
      }
    case USER_TYPES.PROFESSOR:
      return {
        background: colors.ppalProfessor,
      }
    case USER_TYPES.ADMIN:
      return {
        background: colors.ppalAdmin,
      }
    case 'menu':
      return {
        background: `rgba(${hexToRgb(colors.ppalProfessor)}, 0.5)`,
      }
    default:
      return {
        background: '#E8EAF6',
        color: '#3F51B5',
      }
  }
}

const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
    : '0, 0, 0'
}

export const TagContainer = styled.span<TagProps>`
  display: inline-flex;
  align-items: center;
  padding: 5px 8px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  background-color: ${({ $variant }) => getTagColor($variant).background};
  color: ${colors.textPrimary};
`
